export default function R_Global_Variables() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Global_Variables Component</h1>
      <p>This is the R_Global_Variables tutorial section.</p>
    </div>
  );
}
